import React from 'react';
import { toast } from 'react-toastify';
import { format as formatDate } from 'date-fns';

import firebase, { functions } from '../../firebase';
import Page from '../hocs/Page';
import ProgressButton from '../ProgressButton';
import useDocumentSubscription from '../hooks/useDocumentSubscription';

const unsubscribeFromEmail = functions.httpsCallable('unsubscribeFromEmail');
const db = firebase.firestore();

export default Page(function Unsubscribe(props) {
  const {
    match: {
      params: { token, tenantPath },
    },
    history,
  } = props;
  const unsubscribeToken = useDocumentSubscription(db.collection('unsubscribeTokens').doc(token));
  const onClickUnsubscribe = async () => {
    try {
      const response = await unsubscribeFromEmail({ token });
      toast.success(response.data.message);
      // 成功したらテナントトップページにリダイレクト
      setTimeout(() => {
        history.push(`/${tenantPath}/events`);
      }, 2000);
    } catch (err) {
      toast.error(err.message || 'エラーが発生しました');
    }
  };
  // メール種別の説明
  const getEmailTypeDescription = (emailType) => {
    const descriptions = {
      eventFollower: 'イベントのフォロー通知',
      eventCancellationNotice: 'キャンセル待ち通知',
      eventLectureAdd: '日程追加通知'
    };
    return descriptions[emailType] || 'メール通知';
  };
  if (!unsubscribeToken) {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body text-center">
                <h5 className="card-title">メール配信停止</h5>
                <p className="card-text">情報を読み込み中...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (unsubscribeToken.expiresAt?.toDate() < new Date()) {
    return null;
  }

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title text-center mb-4">メール配信停止</h5>

              <div className="mb-4">
                <h6 className="text-muted mb-3">配信停止の詳細</h6>

                <div className="row mb-2">
                  <div className="col-sm-4"><strong>メールアドレス:</strong></div>
                  <div className="col-sm-8">{unsubscribeToken.email}</div>
                </div>

                {unsubscribeToken.userName && (
                  <div className="row mb-2">
                    <div className="col-sm-4"><strong>お名前:</strong></div>
                    <div className="col-sm-8">{unsubscribeToken.userName}</div>
                  </div>
                )}

                <div className="row mb-2">
                  <div className="col-sm-4"><strong>通知種別:</strong></div>
                  <div className="col-sm-8">{getEmailTypeDescription(unsubscribeToken.emailType)}</div>
                </div>

                {unsubscribeToken.eventName && (
                  <div className="row mb-2">
                    <div className="col-sm-4"><strong>対象イベント:</strong></div>
                    <div className="col-sm-8">{unsubscribeToken.eventName}</div>
                  </div>
                )}

                {unsubscribeToken.emailType === 'eventCancellationNotice' && unsubscribeToken.lectureDate && (
                  <div className="row mb-2">
                    <div className="col-sm-4"><strong>対象日程:</strong></div>
                    <div className="col-sm-8">{formatDate(unsubscribeToken.lectureDate.toDate(), 'yyyy年MM月dd日')}</div>
                  </div>
                )}
              </div>

              <div className="alert alert-info">
                <strong>ご確認ください:</strong><br />
                上記の{getEmailTypeDescription(unsubscribeToken.emailType)}の配信を停止します。<br />
                配信停止後は、この種類のメール通知が届かなくなります。
              </div>

              <div className="text-center">
                <ProgressButton
                  color="danger"
                  process={onClickUnsubscribe}
                >
                  配信を停止する
                </ProgressButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
